module.exports = __webpack_public_path__ + "c60cad17addb9f2a8a75d56c44cb9a29.svg";